import React, { useContext, useEffect, useState } from "react";
import useTitle from "../Hooks/useTitle";
import { ButtonComponent } from "@syncfusion/ej2-react-buttons";
import ToastContext from "../Context/toastContext";
import axiosClient from "../Utils/axiosClient";
import { useTranslation } from "react-i18next";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";

const SettingsPage = () => {
  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [isEmailConfirmed, setIsEmailConfirmed] = useState(false);
  const [isFb, setIsFb] = useState(false);

  const { showToast } = useContext(ToastContext);
  const { t } = useTranslation();

  useTitle(`${t("Settings")} | Netileti`);

  const fetchWabaData = async () => {
    try {
      const response = await axiosClient.get(`/users/GetMy`);

      if (response.status === 200) {
        setIsEmailConfirmed(response.data.emailConfirmed);
        if (response.data.wabaid) {
          setIsFb(true);
        }
      } else {
        showToast(
          `${t("Error")}: ${response.statusText}`,
          "Http status :",
          response.status
        );
      }
    } catch (error) {
      showToast(`${t("Error")} : ${error.message}`, `${t("Error")}`);
    }
  };

  const handleResetPass = async () => {
    if (!oldPass || !newPass) {
      showToast(`${t("Please enter valid password")}`, `${t("Error")}`);
      return 0;
    }
    try {
      const response = await axiosClient.post(`/manage/info`, {
        newEmail: localStorage.getItem("userEmail"),
        newPassword: newPass,
        oldPassword: oldPass,
      });

      if (response.status === 200) {
        showToast(
          `${t("Password")} ${t("updated successfully!")}`,
          `${t("Success")}`
        );
      } else {
        showToast(`${t("Failed to update")}`, `${t("Error")}`);
      }
    } catch (error) {
      showToast(`${t("wrongpass")} : ${error.message}`, `${t("Error")}`);
    }
  };

  const handleMailConfirmation = async () => {
    try {
      let email = localStorage.getItem("userEmail");

      const response = await axiosClient.post("/resendConfirmationEmail", {
        email: email,
      });
      if (response.status === 200) {
        showToast(`${t("mailSended")}`, `${t("Success")}`);
      } else {
        showToast(
          `${t("Error")}: ${response.statusText}`,
          "Http status :",
          response.status
        );
      }
    } catch (error) {
      showToast(`${t("Error")} : ${error.message}`, `${t("Error")}`);
    }
  };

  const loadFbSDK = () => {
    if (!window.FB) {
      const script = document.createElement("script");
      script.src = "https://connect.facebook.net/en_US/sdk.js";
      script.async = true;
      script.defer = true;
      script.crossOrigin = "anonymous";
      script.onload = () => {
        window.FB.init({
          appId: "990475258691931",
          cookie: true,
          autoLogAppEvents: true,
          xfbml: true,
          version: "v19.0",
        });
      };
      document.body.appendChild(script);
    }
  };

  useEffect(() => {
    loadFbSDK();
    fetchWabaData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchBusinessId = async (accessToken) => {
    try {
      const response = await fetch(
        `https://graph.facebook.com/v19.0/me?fields=businesses&access_token=${accessToken}`
      );
      const data = await response.json();
      console.log(data);
      if (data.businesses.data && data.businesses.data.length > 0) {
        const businessId = data.businesses.data[0].id;
        fetchWabaId(businessId, accessToken);
      } else {
        console.log("İşletme hesabı bulunamadı.");
      }
    } catch (error) {
      console.error("İşletme ID alınırken hata oluştu:", error);
    }
  };

  const fetchWabaId = async (businessId, accessToken) => {
    try {
      const response = await fetch(
        `https://graph.facebook.com/v19.0/${businessId}/owned_whatsapp_business_accounts?access_token=${accessToken}`
      );
      const data = await response.json();

      if (data.data && data.data.length > 0) {
        try {
          const response = await axiosClient.patch(
            `/Users/updWabaId/${data.data[0].id}`
          );

          if (response.status === 200) {
            showToast(
              `Waba Id ${t("updated successfully!")}`,
              `${t("Success")}`
            );
          } else {
            showToast(`${t("Failed to update")}`, `${t("Error")}`);
          }
        } catch (error) {
          showToast(`${t("Error")} : ${error.message}`, `${t("Error")}`);
        }
      } else {
        console.log("WhatsApp Business hesabı bulunamadı.");
      }
    } catch (error) {
      console.error("WABA ID alınırken hata oluştu:", error);
    }
  };

  const handleFacebookLogin = () => {
    window.FB.login(
      (response) => {
        if (response.authResponse) {
          const accessToken = response.authResponse.accessToken;
          fetchBusinessId(accessToken);
        } else {
          console.log("Kullanıcı giriş yapmadı.");
        }
      },
      // {
      //   scope: "public_profile,email,whatsapp_business_management",
      // }
      {
        scope:
          "public_profile,email,whatsapp_business_management,business_management",
      }
    );
  };

  return (
    <div
      className="content e-content-animation"
      style={{ display: "flex", justifyContent: "center" }}
    >
      <div className="settings">
        <div className="settings-header">
          <h2 style={{ fontWeight: "350" }}>{t("Settings")}</h2>
        </div>
        <div className="settings-content">
          {/*  */}
          <div className="e-card e-card-horizontal">
            <div className="e-card-sub-title">{t("Password")}</div>
            <div className="e-card-content">
              <div className="settings-password">
                <input
                  className="e-input"
                  type="password"
                  placeholder={t("Old Password")}
                  onChange={(e) => setOldPass(e.target.value)}
                  required
                ></input>
                <input
                  className="e-input"
                  type="password"
                  placeholder={t("New Password")}
                  onChange={(e) => setNewPass(e.target.value)}
                  required
                ></input>
                <ButtonComponent
                  cssClass="e-primary e-outline e-small"
                  onClick={handleResetPass}
                >
                  {t("Change")}
                </ButtonComponent>
              </div>
            </div>
          </div>
          {/*  */}
          {/*  */}
          <div className="e-card e-card-horizontal">
            <div className="e-card-sub-title">{t("E-mail Confirmation")}</div>
            <div className="e-card-content">
              <div className="settings-wabaid">
                <ButtonComponent
                  cssClass="e-primary e-small"
                  onClick={handleMailConfirmation}
                  disabled={isEmailConfirmed}
                >
                  {isEmailConfirmed
                    ? localStorage.getItem("userEmail")
                    : t("Send E-mail")}
                </ButtonComponent>
              </div>
            </div>
          </div>
          {/*  */}
          {/*  */}
          <div className="e-card e-card-horizontal">
            <div className="e-card-sub-title">{t("Login with Meta")}</div>
            <div className="e-card-content">
              <div className="settings-wabaid">
                <ButtonComponent
                  cssClass="e-primary e-small"
                  onClick={handleFacebookLogin}
                  disabled={isFb}
                >
                  {isFb ? t("LoggedIn") : t("Login with Meta")}
                </ButtonComponent>
                <TooltipComponent
                  content={`<div>${t("Meta Desc")}</div>`}
                  position="BottomCenter"
                >
                  <span
                    className="e-icons e-large e-circle-info"
                    style={{
                      marginLeft: "8px",
                      fontSize: "25px",
                      cursor: "pointer",
                    }}
                  ></span>
                </TooltipComponent>
              </div>
            </div>
          </div>
          {/*  */}
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
